import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, stringAvatar,} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {SummaryPageVO, useQuerySummaryPage} from "@/service/summary.s";
import {WriteSummary} from "@/pages/Summary/WriteSummary";
import {ViewSummary} from "@/pages/Summary/ViewSummary";
import {Avatar, Typography} from "@mui/material";
import {permScope} from "@/helper/constant";
import {useAuthInfo} from "@/store/account.c";

export const SummaryListPage = () => {
    const {
        mutate: summaryPageMutate,
        data: summaryPageData,
        isPending: summaryPagePending,
    } = useQuerySummaryPage()
    const {role: {dataScope}} = useAuthInfo()
    const columns: GridColDef<SummaryPageVO>[] = [
        {
            field: "title",
            headerName: "标题",
            flex: 0.4,
        },
        {
            field: "category",
            headerName: "总结类型",
            headerAlign: "center",
            align: "center",
            flex: 0.3,
            display: "flex",
            renderCell: ({row}) => <Typography color={'info'}>{row.category}</Typography>,
        },
        {
            field: "isEvaluate",
            headerName: "是否回复",
            headerAlign: "center",
            align: "center",
            flex: 0.25,
            display: "flex",
            renderCell: ({row}) => <Typography>{row.isEvaluate ? '已回复' : '未回复'}</Typography>,
        },
        {
            field: "reply",
            headerName: "回复内容",
            headerAlign: "center",
            align: "center",
            flex: 0.35,
            valueFormatter: value => value || "-"
        },
        {
            field: "isRead",
            headerName: "是否阅读",
            headerAlign: "center",
            align: "center",
            flex: 0.25,
            display: "flex",
            renderCell: ({row}) => <Typography color={row.isRead ? 'textSecondary' : 'error'}>{row.isRead ? '已阅读' : '未阅读'}</Typography>,
        },
        {
            field: "creator",
            headerName: "创建人",
            headerAlign: "center",
            align: "center",
            display: 'flex',
            flex: 0.3,
            renderCell: ({row}) => <Avatar {...stringAvatar(row.creator)} />
        },

        {
            field: "createdAt",
            headerName: "创建时间",
            headerAlign: "center",
            flex: 0.3,
            align: "center",
            valueFormatter: (value) => formatTime("D", value) || '-',
        },
    ];

    return (
        <ProTable<SummaryPageVO>
            loading={summaryPagePending}
            columnVisibilityModel={{creator: dataScope !== permScope['self']}}
            renderDrawer={{view: <ViewSummary/>, write: <WriteSummary/>}}
            columns={columns}
            data={summaryPageData?.data}
            drawerProps={{
                view: {
                    hiddenFooter: true
                }
            }}
            onSearch={(params) => {
                summaryPageMutate(params);
            }}
            code={"summary"}
        />
    );
};
